import * as React from 'react'
import { observer } from 'mobx-react'
import ProfileViewModel from '../../ProfileViewModel'
import SectionEmpty from '../../SectionEmpty'
import SelectionList from '../../SelectionList'
import Icon from 'components/Icon'
import SelectionEditorDialog from '../../SelectionEditorDialog'

interface SkillsProps {
  vm: ProfileViewModel
}

export default observer(function Skills({ vm }: SkillsProps) {
  const createList = (editing: boolean) => (
    <SelectionList
      selectionVM={vm.general.skillSelection}
      icon={<Icon name="skills" />}
      editing={editing}
      getContent={(item) => ({
        title: item.name,
        description: item.description,
      })}
    />
  )

  return (
    <>
      {vm.general.skillSelection.selectedItems.length === 0 ? (
        <SectionEmpty>
          You haven't added any skills yet — lets change that!
        </SectionEmpty>
      ) : (
        createList(false)
      )}
      <SelectionEditorDialog
        title="Manage your Skills"
        description={
          <>
            Select the skills that represent the type of requests you are
            comfortable with.
          </>
        }
        selectionVM={vm.general.skillSelection}
      >
        {createList(true)}
      </SelectionEditorDialog>
    </>
  )
})
